import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { WishlistTemplateToken } from '@sleed/bizcommerce-api';
import { wishlistTemplatesApi } from '~/lib/api/client';
import { formToToken, type WishlistTemplateFormValues } from '~/lib/schemas/wishlist-template';

export const wishlistTemplateKeys = {
	all: ['wishlist-templates'] as const,
	list: () => [...wishlistTemplateKeys.all, 'list'] as const
};

export function useWishlistTemplatesList() {
	return useQuery<WishlistTemplateToken[]>({
		queryKey: wishlistTemplateKeys.list(),
		queryFn: async () => (await wishlistTemplatesApi.getAll()).data.items ?? []
	});
}

export function useWishlistTemplateMutations() {
	const qc = useQueryClient();
	const invalidate = () => qc.invalidateQueries({ queryKey: wishlistTemplateKeys.list() });
	const create = useMutation({
		mutationFn: async (form: WishlistTemplateFormValues) => (await wishlistTemplatesApi.insert(formToToken(form))).data,
		onSuccess: invalidate
	});
	const update = useMutation({
		mutationFn: async (form: WishlistTemplateFormValues) => (await wishlistTemplatesApi.update(formToToken(form))).data,
		onSuccess: invalidate
	});
	const remove = useMutation({
		mutationFn: async (id: number) => (await wishlistTemplatesApi.remove(id)).data,
		onSuccess: invalidate
	});
	return { create, update, remove };
}
